import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { ExternalRecordCount, ExternalRecordCountResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<ExternalRecordCountResponse, ExternalRecordCountResponse>) => response?.data?.count;
const getError = (response?: SWRResponse<ExternalRecordCountResponse, ExternalRecordCountResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<ExternalRecordCountResponse, ExternalRecordCountResponse>) => ({});

const useGetExternalRecordCount = (query?: Partial<ExternalRecordCount>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new ExternalRecordCount(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetExternalRecordCount;